import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface HeaderProps {
  workflowId?: string;
  title?: string;
  subtitle?: string;
  showBackButton?: boolean;
  onClick?: () => void;
  btnText?: string;
  btnVariant?: 'contained' | 'outlined' | 'text';
  startIcon?: React.ReactNode;
}

export const Header: React.FC<HeaderProps> = ({
  workflowId,
  title,
  subtitle,
  showBackButton = true,
  onClick,
  btnText,
  btnVariant,
  startIcon,
}) => {

    const navigate = useNavigate();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={6}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>

      <Box display="flex" gap={1} sx={{ opacity: 0.6 }}>          
          {workflowId && (
            <Paper sx={{ 
              bgcolor: '#f8f8f8', 
              p: 0.5, 
              px: 1 
            }}>
              <Typography variant="caption" color="text.secondary">
                WF: {workflowId.substring(0, 6)}...
              </Typography>
            </Paper>
          )}
        </Box>
      
      <Box display="flex" gap={2} alignItems="center">
        {showBackButton && (
          <Button
            variant={btnVariant || 'outlined'}
            color="primary"
            startIcon={startIcon || <ArrowLeft size={20} />}
            onClick={onClick ? onClick : () => navigate('/start-process')}
            sx={{ 
              py: 1.5, 
              px: 3,
              fontSize: '1rem',
              fontWeight: 'bold'
            }}
          >
            {btnText || 'Start Process'}
          </Button>
        )}        
       
      </Box>
    </Box>
  );
};
